import React, { Component } from 'react'
import ColorPicker from './components/ColorPicker'

class App extends Component {
  render() {
    return <ColorPicker />
  }
}

export default App
